import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1900ff8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container background" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-header" }, "PEAK Affiliate", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignInFormComponent = _resolveComponent("SignInFormComponent")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "card",
      width: "600",
      "max-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_item, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_SignInFormComponent, { "get-sign-in-error": _ctx.getSignInError }, null, 8, ["get-sign-in-error"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}